import { put, call } from 'redux-saga/effects';
import { chatBoxCreateAPI, chatBoxSearchAPI, chatBoxUpdateAPI } from 'src/api/ChatBoxApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { CHATBOX_ACTIONS } from '../actions/ChatBoxActions';
import { toast } from 'react-toastify';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(chatBoxSearchAPI, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
            }),
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: CHATBOX_ACTIONS.CHATBOX_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: CHATBOX_ACTIONS.CHATBOX_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(chatBoxSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        
        yield put({
            type: CHATBOX_ACTIONS.CHATBOX_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(chatBoxCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        })); 
        toast("ChatBox Created")
        
        yield put({
            type: CHATBOX_ACTIONS.CHATBOX_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
        yield put({
            type: CHATBOX_ACTIONS.CHATBOX_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: CHATBOX_ACTIONS.CHATBOX_UPSERT_ERROR,
        });
    }
}

function* update(chatBoxId, payload) {
    try {
        yield call(chatBoxUpdateAPI, {
            chatBoxId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if(payload.deleted===true){
            toast("ChatBox deleted")
        }
        else{
            toast("ChatBox updated")
        } 
        
        yield put({
            type: CHATBOX_ACTIONS.CHATBOX_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: CHATBOX_ACTIONS.CHATBOX_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(CHATBOX_ACTIONS.CHATBOX_SEARCH, search),
    takeFirstSagaUtil(CHATBOX_ACTIONS.CHATBOX_UPSERT, upsert),
    takeFirstSagaUtil(CHATBOX_ACTIONS.CHATBOX_EDIT, edit),
];
